import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../../config';

import { navigation_toggle_close, navigation_geo_toggle_open, navigation_geo_toggle_close } from './../../redux/reducers/navigationSlice';
import Track from './../../helpers/AnalyticsTracker';
import NavChannel from './NavChannels/NavChannel';
import NavChannelLoading from './NavChannels/NavChannelLoading';
import NavGeographies from './NavGeography/NavGeographies';
import NavChannelCompareCountries from './NavChannels/NavChannelCompareCountries';
// tslint:disable:jsx-no-multiline-js

import {
   NavPickerWrapper,
   NavPickerMetaContainer,
   NavPickerMetaLeft,
   NavPickerMetaTriggerContainer,
   NavPickerMetaTriggerLeft,
   NavPickerMetaTriggerText,
   NavPickerMetaTriggerRight,
   NavPickerMetaCenter,
   BecomeAClientSubmit,
   NavPickerMetaRight
} from './NavCollectionsPicker.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons';
import { COLOR } from '../../theme/constants';

function mapStateToProps(state, ownProps) {
   return {
      NavOpen: state.navigation.navOpen,
      SelectedGeography: state.navigation.selectedGeography,
      Channels: state.navigation.channels,
      CompareCountries: state.navigation.compareCountries,
      isLoggedIn: state.auth.authenticated
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      navToggleClose: (templateGeo: string) => {
         dispatch(navigation_geo_toggle_close());
         dispatch(navigation_toggle_close(templateGeo));
      },
      navGeoToggleOpen: () => {
         dispatch(navigation_geo_toggle_open());
      }
   };
};

class NavCollectionsPicker extends Component<
   {
      NavOpen: boolean;
      navToggleClose: any;
      navGeoToggleOpen: any;
      SelectedGeography: string;
      TemplateGeography: string;
      Channels: any;
      CompareCountries: any;
      isLoggedIn: boolean;
      isMobile: boolean;
      isHomePage: boolean;
   },
   {
      navMenuWrapperRef: any;
   }
> {
   constructor(props) {
      super(props);
      (this.state = {
         navMenuWrapperRef: null
      }),
         (this.onClick = this.onClick.bind(this));
      this.setNavMenuWrapperRef = this.setNavMenuWrapperRef.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
   }

   public componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
   }

   public componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
   }

   private setNavMenuWrapperRef(node) {
      this.setState({
         navMenuWrapperRef: node
      });
   }

   private handleClickOutside(event) {
      if (this.props.NavOpen) {
         if (this.state.navMenuWrapperRef && !this.state.navMenuWrapperRef.contains(event.target) && this.props.isHomePage === false) {
            Track('NavigationMenu-ClickOutsideToClose');
            this.props.navToggleClose(this.props.SelectedGeography);
         } else {
            return false;
         }
      }
   }

   private onClick() {
      this.props.navToggleClose(this.props.SelectedGeography);
   }

   public render() {
      const { NavOpen, SelectedGeography, Channels, CompareCountries, isLoggedIn, isMobile, isHomePage } = this.props;

      const hiddenElementStyles = () => {
         const isOpen = NavOpen ? 'active' : '';
         return `${isOpen}`;
      };

      const NavigationCloseHidden = () => {
         const isOpen = isHomePage ? '' : 'active';
         return `${isOpen}`;
      };

      const channelsList = Channels.filter(channel => channel.TopicName.toLowerCase() != 'companies').map((channel, index) => (
         <NavChannel key={index} channelTitle={channel.TopicName} channelList={channel.Collections} isMobile={isMobile} />
      ));

      const companiesChannel = Channels.filter(channel => channel.TopicName.toLowerCase() == 'companies').map(channel => (
         <NavChannel key={99} channelTitle={channel.TopicName} channelList={channel.Collections} isMobile={isMobile} />
      ));

      return (
         <NavPickerWrapper className={'fr-picker ' + hiddenElementStyles()} ref={this.setNavMenuWrapperRef}>
            <NavPickerMetaContainer>
               <NavPickerMetaLeft>
                  <NavPickerMetaTriggerContainer
                     data-analytics='Forecasts-Navigation-Geographies-Open'
                     id='Forecasts-Navigation-Geographies-Open'
                     onClick={() => this.props.navGeoToggleOpen()}
                  >
                     <NavPickerMetaTriggerLeft>
                        <NavPickerMetaTriggerText>{SelectedGeography}</NavPickerMetaTriggerText>
                     </NavPickerMetaTriggerLeft>
                     <NavPickerMetaTriggerRight>
                        <FontAwesomeIcon icon={faChevronDown} color={COLOR.BLUE} width={14} />
                     </NavPickerMetaTriggerRight>
                  </NavPickerMetaTriggerContainer>
               </NavPickerMetaLeft>

               {!isLoggedIn && config.pod == 'NAX' && !isMobile ? (
                  <NavPickerMetaCenter>
                     <span>Powerful data and analysis</span> on nearly every digital topic.
                     <BecomeAClientSubmit>
                        <a
                           href={`${config.iiHomeUrl}/become-a-client/`}
                           rel='noreferrer'
                           data-analytics='Forecasts-Home-CTA-BecomeAClient'
                           id='Forecasts-Home-CTA-BecomeAClient'
                        >
                           Become a Client
                        </a>
                     </BecomeAClientSubmit>
                  </NavPickerMetaCenter>
               ) : null}

               <NavPickerMetaRight data-analytics='Forecasts-Navigation-Close' onClick={this.onClick} className={NavigationCloseHidden()} buttonType='none'>
                  <FontAwesomeIcon icon={faTimes} color={COLOR.BLUE} style={{ marginBottom: '4px', display: 'block', width: '14px', height: '14px' }} />
                  <span>CLOSE</span>
               </NavPickerMetaRight>
            </NavPickerMetaContainer>
            {channelsList}
            {<NavChannelCompareCountries collections={CompareCountries} isMobile={isMobile} />}
            {companiesChannel}
            {<NavGeographies />}
         </NavPickerWrapper>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavCollectionsPicker);
